import { useEffect } from 'react';

/**
 * 네비게이션 오프셋 리스너 등록 커스텀 훅
 * 스크롤 시 사이드바 위치 업데이트
 */
export const useNavOffsets = (navLayout) => {
  useEffect(() => {
    if (typeof window.ThemeApply !== 'undefined' && typeof window.ThemeApply.attachNavOffsetsListeners === 'function') {
      window.ThemeApply.attachNavOffsetsListeners();
    } else if (typeof window.attachNavOffsetsListeners === 'function') {
      window.attachNavOffsetsListeners();
    }

    // 초기 오프셋 계산
    if (typeof window.updateNavOffsets === 'function') {
      window.updateNavOffsets();
    }
  }, [navLayout]);
};
